module.exports = __webpack_public_path__ + "static/media/logo.f9b92409.svg";